module.exports = __webpack_public_path__ + "img/browser@2x.920b0cfb.png";